import { compareDatePart } from '../dateMath/dateMath';
/**
 * Generates a list of dates, bounded by min and max dates
 * @param dateRange - input date range
 * @param minDate - min date to limit the range
 * @param maxDate - max date to limit the range
 */ export const getBoundedDateRange = (dateRange, minDate, maxDate)=>{
    let boundedDateRange = [
        ...dateRange
    ];
    if (minDate) {
        boundedDateRange = boundedDateRange.filter((date)=>compareDatePart(date, minDate) >= 0);
    }
    if (maxDate) {
        boundedDateRange = boundedDateRange.filter((date)=>compareDatePart(date, maxDate) <= 0);
    }
    return boundedDateRange;
};
